/**
 * Sticky per-visitor 50/50 assignment (localStorage key `ab_<testKey>`).
 * `?v=a|b` forces and persists an arm, for QA and campaign links.
 * Tag funnel events with the returned value as `variant`: that GA4 custom
 * dimension is what the ab-testing skill's ab.py splits on.
 */
export type ABVariant = 'A' | 'B';

export function abVariant(testKey: string): ABVariant {
  const key = `ab_${testKey}`;
  try {
    const forced = new URLSearchParams(window.location.search).get('v')?.toUpperCase();
    const stored = localStorage.getItem(key);
    const variant: ABVariant =
      forced === 'A' || forced === 'B' ? forced
        : stored === 'A' || stored === 'B' ? stored
          : Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(key, variant);
    return variant;
  } catch {
    return 'A'; // storage blocked: serve control, never throw on a render path
  }
}
